import { api } from './config';
import { ApiResponse } from '../types';

export interface McpAuthApproveRequest {
  clientId: string;
  redirectUri: string;
  codeChallenge: string;
  codeChallengeMethod: string;
  scope?: string;
  state?: string;
}

export interface McpAuthApproveResponse {
  redirect: string;
}

export const mcpOAuthApi = {
  /** Backend Jackson 전역 SNAKE_CASE — request body 도 snake_case 키로 변환. */
  approve: (data: McpAuthApproveRequest) =>
    api.post<ApiResponse<McpAuthApproveResponse>>('/oauth/authorize/approve', {
      client_id: data.clientId,
      redirect_uri: data.redirectUri,
      code_challenge: data.codeChallenge,
      code_challenge_method: data.codeChallengeMethod,
      scope: data.scope,
      state: data.state,
    }),
};
